export const BAD = "BAD";
export const WARNING = "WARNING";
export const OK = "OK";
